import React, {Component, useContext} from 'react';
import ReactDOM from 'react-dom';
import { Layout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import { ButtonCancel, ButtonModify, ButtonProceed, ButtonRemove, ButtonReturn, ButtonSave, ButtonView } from '../../../../components/buttons';
import Container from '../../../../layouts/containers/container';

import TabBar from '../../components/tab-bar';
import companiesApi from '../../../../lib/companies/companies-api';
import User from '../../../../icons/user';
import List from '../../../../components/list';
import ContainerIndex from '../../../../layouts/containers/container-index';
import Divider from '../../../../components/divider/divider';
import Grid from '../../../../components/grid';
import InputsText from '../../../../components/inputs/inputs-text';
import InputsDropdown from '../../../../components/inputs/inputs-dropdown';
import PopupContext from '../../../../context/context-popup';
import PopupsDeleteMember from '../../popups/popups-delete-member';
import PopupsInviteUser from '../../popups/popups-invite-user';
import ContentDropdown from '../../../../components/content-dropdown';
import PopupsRemoveInvite from '../../popups/popups-remove-invite';
import LabelContainer from '../../../../components/label-container';
import { stringToFriendlyDatetime } from '../../../../lib/helpers/datetime-helpers';
import adminApi from '../../../../lib/admin/admin-api';
import { toast } from 'react-toastify';
import auth, { CompanyPermissions } from '../../../../lib/users/auth';

const el = document.getElementById('account-company');

const Card = ({
    member
}) => {
    const { setPopup } = useContext(PopupContext);

    const deleteMember = () => setPopup(<PopupsDeleteMember member={member}/>);

    return (
        <Container className="member-card">
            <Container.Header>
                <Row gap="10px" alignItems="center">
                    <Container.Icon src={User}/>
                    <List gap="5px">
                        <Container.Text fontSize="12px" color="#FF7612">{ member?.roles?.map(({ name }) => name).join(', ') }</Container.Text>
                        <Container.Text fontSize="16px" color="#151515">{ member?.name }</Container.Text>
                    </List>
                </Row>
            </Container.Header>
            <Container.Content>
                <List gap="40px">
                    <Container.Text fontSize="14px" color="#354859">{ member?.email }</Container.Text>
                    <Row gap="10px" justifyContent="flex-end">
                        <ButtonView mobile onClick={() => window.location.href = `/mydmc/account/company/user/${member?.id}`}/>
                        <ButtonRemove mobile onClick={deleteMember}/>
                    </Row>
                </List>
            </Container.Content>
        </Container>
    )
}

class InviteStaff extends Component {
    static contextType = PopupContext;

    constructor() {
        super();

        this.state = {
            invites: [],
            meta: {},
            page: 1,
            roles: []
        }
    }

    componentDidMount() {
        this.fetch();
        this.fetchRoles();
    }

    fetch() {
        companiesApi.userInvites(window.user?.company_id, {
            page: this.state.page,
            per_page: 6
        }).then(({ data, meta }) => {
            this.setState({ invites: data, meta })
        });
    }

    fetchRoles() {
        adminApi.getRoles().then(({ data }) => {
            this.setState({ roles: data });
        })
    }

    invite() {
        this.context.setPopup(<PopupsInviteUser onSuccess={this.fetch.bind(this)}/>);
    }

    onNext() {
        this.setState({ page: this.state.page + 1 }, this.fetch.bind(this));
    }

    onPrevious() {
        this.setState({ page: this.state.page - 1 }, this.fetch.bind(this));
    }

    removeInvite(invite) {
        this.context.setPopup(<PopupsRemoveInvite invite={invite} onSuccess={this.fetch.bind(this)}/>);
    }

    render() {
        return (
            <Container>
                <Container.Header>
                    <Row gap="20px" justifyContent="space-between" alignItems="center">
                        <Container.Text fontSize="30px" color="#FF6933">Invite Staff</Container.Text>
                        <ButtonModify mobile onClick={this.invite.bind(this)}/>
                    </Row>
                </Container.Header>

                <Container.Content>
                    <List gap="20px">
                        { this.state.invites?.map((invite, index) => {
                            const roles = invite?.role_ids?.map(id => {
                                return this.state.roles?.find(role => role.id === id)
                            })

                            return <ContentDropdown 
                                title={invite?.email}
                                key={index} 
                                right={
                                    <ButtonRemove mobile onClick={() => this.removeInvite(invite)}/>
                                }
                            >
                                <List gap="20px">
                                    <LabelContainer label={<Container.Text color="#1976F8">Expires</Container.Text>}>
                                        { stringToFriendlyDatetime(invite?.expires) }
                                    </LabelContainer>

                                    <LabelContainer label={<Container.Text color="#1976F8">Roles</Container.Text>}>
                                        { roles?.map((role) => role?.name)?.join(', ') }
                                    </LabelContainer>
                                </List>
                            </ContentDropdown>
                        })}

                        <ContainerIndex.Pagination
                            currentPage={this.state.page}
                            maxPages={this.state.meta?.last_page}
                            onNext={this.onNext.bind(this)}
                            onPrevious={this.onPrevious.bind(this)}
                        />
                    </List>
                </Container.Content>
            </Container>
        )
    }
}

class Company extends Component {
    constructor() {
        super();

        this.state = {
            members: [],
            meta: {},
            page: 1,
            company: null,
            industries: [],
            errors: {},
            profileErrors: {}
        }
    }

    componentDidMount() {
        this.fetch();
        this.fetchIndustries();
    }

    async save() {
        companiesApi.update(window.user?.company_id, this.state.company, (errors) => {
            this.setState({ errors })
        }).then(() => {
            this.fetch();
    
            toast.success('Successfully updated your company', {
                position: toast.POSITION.BOTTOM_CENTER,
                icon: false,
            })

            companiesApi.updateProfile(window.user?.company_id, this.state.company?.company_profile, (errors) => {
                this.setState({ profileErrors: errors })
            }).then(() => {
                toast.success('Successfully updated your company profile', {
                    position: toast.POSITION.BOTTOM_CENTER,
                    icon: false,
                })
            });
        });
    }

    fetch() {
        companiesApi.getCompany(window.user?.company_id).then(({ data }) => {
            this.setState({ company: data });
        });

        companiesApi.getCompanyMembers(window.user?.company_id, {
            per_page: 6,
            page: this.state.page,
        }).then(({ data, meta }) => {
            this.setState({ members: data, meta })
        })
    }

    fetchIndustries() {
        companiesApi.getIndustries().then(({ data }) => {
            this.setState({ industries: data });
        }); 
    }

    onNext() {
        this.setState({ page: this.state.page + 1 }, this.fetch.bind(this));
    }

    onPrevious() {
        this.setState({ page: this.state.page - 1 }, this.fetch.bind(this));
    }

    onChange(e) {
        const { name, value } = e.target;
        const company = { ...this.state.company };

        company[name] = value;

        this.setState({ company })
    }

    onCompanyProfileChange(e) {
        const { name, value } = e.target;

        const company = { ...this.state.company }
        const profile = company?.company_profile;

        profile[name] = value;

        this.setState({ company });
    }

    onProfileChange(e) {
        const { name, value } = e.target;

        const company = { ...this.state.company }
        const company_profile = company?.company_profile;
        const profile = company_profile?.profile !== null ? company_profile?.profile : {};

        profile[name] = value;
        company_profile.profile = profile;

        this.setState({ company });
    }

    isUserAdmin() {
        return auth.hasPermission(CompanyPermissions.COMPANY_OWNER) ||  auth.hasPermission(CompanyPermissions.COMPANY_MANAGER);
    }

    renderAdmin() {
        return (
            <List gap="20px">
                <Grid columns={2} gap="20px">
                    <InputsText
                        label="Company Name"
                        name="name"
                        value={this.state.company?.name}
                        errors={this.state?.errors?.name}
                        onChange={this.onChange.bind(this)}
                    />

                    <InputsText
                        label="Company Registration Number"
                        name="sap_number"
                        value={this.state.company?.company_profile?.profile?.sap_number}
                        errors={this.state?.profileErrors?.sap_number}
                        onChange={this.onProfileChange.bind(this)}
                    />
                </Grid>

                <Grid columns={2} gap="20px">
                    <InputsDropdown
                        fit
                        label="Industry"
                        errors={this.state?.errors?.company_industry_id}
                        items={this.state.industries?.map((ind) => {
                            return {
                                label: ind?.name,
                                value: ind?.id
                            }
                        })}
                        value={this.state.company?.company_industry_id}
                        onChange={(e) => {
                            this.onChange({
                                target: {
                                    name: 'company_industry_id',
                                    value: e.value
                                }
                            })
                        }}
                    />

                    <InputsDropdown
                        fit
                        label="Number of employees"
                        name="number_of_employees_range"
                        errors={this.state?.profileErrors?.number_of_employees_range}
                        items={[
                            { label: '1-10', value: '1-10' },
                            { label: '11-50', value: '11-50' },
                            { label: '51-150', value: '51-150' },
                            { label: '151-250', value: '151-250' },
                            { label: '251+', value: '251+' }
                        ]}
                        value={this.state.company?.company_profile?.profile?.number_of_employees_range}
                        onChange={(e) => {
                            this.onProfileChange({
                                target: {
                                    name: 'number_of_employees_range',
                                    value: e.value
                                }
                            })
                        }}
                    />
                </Grid>

                <InputsText
                    label="Address 1"
                    name="address_one"
                    value={this.state.company?.company_profile?.profile?.address_one}
                    onChange={this.onProfileChange.bind(this)}
                    errors={this.state?.profileErrors?.address_one}
                />

                <InputsText
                    label="Address 2"
                    name="address_two"
                    value={this.state.company?.company_profile?.profile?.address_two}
                    onChange={this.onProfileChange.bind(this)}
                    errors={this.state?.profileErrors?.address_two}
                />

                <Grid columns={2} gap="20px">
                    <InputsText
                        label="City"
                        name="address_city"
                        value={this.state.company?.company_profile?.profile?.address_city}
                        onChange={this.onProfileChange.bind(this)}
                        errors={this.state?.profileErrors?.address_city}
                    />
                    <InputsText
                        label="Post Code"
                        name="address_postcode"
                        value={this.state.company?.company_profile?.profile?.address_postcode}
                        onChange={this.onProfileChange.bind(this)}
                        errors={this.state?.profileErrors?.address_postcode}
                    />
                </Grid>
            </List>
        )
    }

    renderUser() {
        return (
            <Grid columns={2} gap="20px">
                <LabelContainer label="Company Name">
                    { this.state.company?.name }
                </LabelContainer>

                <LabelContainer label="Company Registration Number">
                    { this.state.company?.company_profile?.profile?.sap_number }
                </LabelContainer>

                <LabelContainer label="Industry">
                    { this.state.industries.find(i => i.id === this.state.company?.company_industry_id)?.name }
                </LabelContainer>

                <LabelContainer label="Number of employees">
                    { this.state.company?.company_profile?.profile?.number_of_employees_range }
                </LabelContainer>

                <LabelContainer label="Address 1">
                    { this.state.company?.company_profile?.profile?.address_one }
                </LabelContainer>

                <LabelContainer label="Address 2">
                    { this.state.company?.company_profile?.profile?.address_two }
                </LabelContainer>
            
                <LabelContainer label="City">
                    { this.state.company?.company_profile?.profile?.address_city }
                </LabelContainer>

                <LabelContainer label="Post Code">
                    { this.state.company?.company_profile?.profile?.address_postcode }
                </LabelContainer>
            </Grid>
        )
    }

    renderContent() {
        if (this.isUserAdmin()) return this.renderAdmin();

        return this.renderUser();
    }

    render() {
        return (
            <Layout 
                theme="light"
                topLeft={
                    <Welcome 
                        title={<Container.Text fontSize="18px" color="#FF6933">Manage</Container.Text>}
                        subtitle="My Company"
                    />
                }
                topRight={
                    <Row gap="20px">
                        { this.isUserAdmin() && <ButtonSave onClick={this.save.bind(this)}>Save</ButtonSave> }
                        <ButtonReturn>Cancel</ButtonReturn>
                    </Row>
                }
            >
            <List gap="40px">
                <TabBar active={1}/>

                <List gap="40px" divider={<Divider/>}>
                    <Container>
                        <Container.Header>
                            <Container.Text fontSize="30px" color="#FF6933">Overview</Container.Text>
                        </Container.Header>

                        <Container.Content>
                            { this.renderContent() }
                        </Container.Content>
                    </Container>
                </List>
            </List>
        </Layout>
        )
    }
}

if (el) {
    ReactDOM.render(
        <Company/>    
    , el);
}
